import { formatDateOnly } from '../../../common/utils/date';

// Sesiones TE asociadas a esta OPU (decisión 0019) → reanudar. El payload derivado
// trae code/date/status + las transferencias de ESTA OPU + embriones; NO trae
// finca/cliente por sesión (se reporta al orquestador). `resume.available_count`
// = embriones de la OPU disponibles para una nueva TE.

const STATUS_LABEL = { 2: 'Activa', 1: 'Inactiva', 0: 'Eliminada' };

export default function ResumeList({ data, loading, onResume }) {
    const sessions = data?.transfer_sessions ?? [];
    const availableCount = data?.resume?.available_count ?? null;

    return (
        <section className="transfer-resume">
            <h2 className="transfer-resume__title">Sesiones de transferencia de esta OPU</h2>

            {loading ? (
                <p className="transfer-resume__empty">Cargando sesiones…</p>
            ) : !sessions.length ? (
                <p className="transfer-resume__empty">Aún no hay transferencias registradas para esta OPU.</p>
            ) : (
                <ul className="transfer-resume__list">
                    {sessions.map((s) => (
                        <li key={s.id} className="transfer-resume__card">
                            <div className="transfer-resume__body">
                                <div className="transfer-resume__head">
                                    <span className="transfer-resume__code">{[s.client?.name, s.farm?.name].filter(Boolean).join(' · ') || s.code}</span>
                                    <span className={`transfer-resume__badge transfer-resume__badge--${s.status}`}>{STATUS_LABEL[s.status] || '—'}</span>
                                </div>
                                <span className="transfer-resume__meta">
                                    {s.code} · {formatDateOnly(s.date)} · {(s.transfers?.length ?? 0)} transferencia(s) de esta OPU · {(s.embryos?.length ?? 0)} embrión(es)
                                </span>
                            </div>
                            <button type="button" className="transfer-resume__resume" onClick={() => onResume(s)}>Reanudar</button>
                        </li>
                    ))}
                </ul>
            )}

            {availableCount != null && (
                <p className="transfer-resume__pool">{availableCount} embrión(es) de esta OPU disponible(s) para una nueva transferencia.</p>
            )}
        </section>
    );
}
